import React, {useEffect, useRef, useState} from 'react';
import {webInfo} from "../../../utils/webInfo";
import {FileUpload} from "primereact/fileupload";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {Card} from "primereact/card";
import useApi from "../../../hooks/useApi";
import usePost from "../../../hooks/usePost";
import {useParams} from "react-router-dom";
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";
import {InputTextarea} from "primereact/inputtextarea";
import callToast, {catchError, showErrors} from "../../../utils/helper";
import {Calendar} from "primereact/calendar";
import moment from "moment/moment";
import {Skeleton} from "primereact/skeleton";
import {InputSwitch} from "primereact/inputswitch";
import {Toast} from "primereact/toast";
import TextEditor from "../../../components/TextEditor";

const InnovationDetails = () => {
    const toast = useRef<any>(null);
    const {id} = useParams();
    const [blog,setBlog]=useState<any>({})
    const categoryUrl = `${webInfo.baseUrl}/api/admin/blogs-category?page=1&per_page=200`
    const url = `${webInfo.baseUrl}/api/admin/blogs/${id}`
    const {get, loading} = useApi<any>();
    const {post,loading:ploading} = usePost()
    const [category,setCategory]=useState<any>([])

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res: any = await get(categoryUrl);
                const options = res.data.data.map((item:any)=>{
                    return {
                        name: item.title,
                        code: item.id,
                    }
                })
                setCategory(options);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchCategories();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!id) return
        const fetchItem = async () => {
            try {
                const res: any = await get(url);
                const {title,author,image,content,meta_title,meta_description,meta_keywords,is_published,category_id,short_description,meta_image,meta_robots,meta_author,tags,published_at} = res.data
                setBlog({
                    title,author,image,content,meta_title,meta_description,meta_keywords,is_published,category_id,short_description,meta_image,meta_robots,meta_author,tags,published_at:moment(published_at, "YYYY-MM-DD HH:mm:ss").toDate()
                });
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchItem();
        // eslint-disable-next-line
    },[id])

    const defaultImagePreviewer = () => {
        return (
            <div
                className="flex align-items-center cursor-pointer"
            >
                {blog.image ? (
                    <div className="p-fileupload-preview flex justify-content-between items-center w-full">
                        <div className="flex">
                            <img
                                alt="Default"
                                src={`${webInfo.baseUrl}/${blog?.image}`} height="50"/>
                            <div className="ml-2">
                                <p className="mb-2">{blog?.image.split("/").at(-1)}</p>
                                <div className="flex align-items-center">
                                    <p className="m-0">00.00 KB</p>
                                    <Badge className="ml-2" value="Default"></Badge>
                                </div>
                            </div>
                        </div>
                        <Button onClick={()=>setBlog({...blog,image: ""})} icon="pi pi-times" className="mr-2" rounded text severity="danger" aria-label="Cancel" />
                    </div>) : (
                    <>
                        <span style={{
                            fontSize: '1em',
                            color: 'var(--text-color-secondary)'
                        }}>
                            Upload Image
                        </span>
                    </>
                )}
            </div>
        )
    }

    const onUpload = (event: any) => {
        setBlog({
            ...blog,
            image:event.files[0],
        })
    };

    const onRemove = () => {
        setBlog({
            ...blog,
            image: ""
        })
    };

    const defaultMetaImagePreviewer = () => {
        return (
            <div
                className="flex align-items-center cursor-pointer"
            >
                {blog.meta_image ? (
                    <div className="p-fileupload-preview flex justify-content-between items-center w-full">
                        <div className="flex">
                            <img
                                alt="Default"
                                src={`${webInfo.baseUrl}/${blog?.meta_image}`} height="50"/>
                            <div className="ml-2">
                                <p className="mb-2">{blog?.meta_image.split("/").at(-1)}</p>
                                <div className="flex align-items-center">
                                    <p className="m-0">00.00 KB</p>
                                    <Badge className="ml-2" value="Default"></Badge>
                                </div>
                            </div>
                        </div>
                        <Button onClick={()=>setBlog({...blog,meta_image: ""})} icon="pi pi-times" className="mr-2" rounded text severity="danger" aria-label="Cancel" />
                    </div>) : (
                    <>
                        <span style={{
                            fontSize: '1em',
                            color: 'var(--text-color-secondary)'
                        }}>
                            Upload Image
                        </span>
                    </>
                )}
            </div>
        )
    }

    const onMetaUpload = (event: any) => {
        setBlog({
            ...blog,
            meta_image:event.files[0],
        })
    };

    const onMetaRemove = () => {
        setBlog({
            ...blog,
            meta_image: ""
        })
    };

    const handleChange = (e: any) => {
        setBlog({
            ...blog,
            [e.target.name]: e.target.value,
        })
    }

    // const updateBlog = async () => {
    //
    //     const formData = new FormData();
    //     const payload:any = {
    //         ...blog,
    //     }
    //     for (const key in payload) {
    //         const value = payload[key as keyof typeof payload];
    //         if (value !== null && value.length > 0) {
    //             if (key === "image" && typeof value === "string") continue;
    //             if (key === "published_at") continue;
    //             if (key === "meta_image") continue;
    //             if (key === "is_published") {
    //                 const publishValue = blog?.is_published ? 1 : 0
    //                 formData.append('is_published', `${publishValue}`);
    //                 continue;
    //             }
    //             if (key === "tags" && typeof value === "string") {
    //                 continue;
    //             }
    //             formData.append(key, payload[key]);
    //         }
    //     }
    //     if (blog.tags.length > 0) {
    //         blog?.tags.map((tag:any) => formData.append('tags[]', tag?.tag))
    //     }
    //     if (blog.published_at){
    //         const formatedData = moment(blog.published_at).format("YYYY-MM-DD")
    //         formData.append('published_at', formatedData);
    //     }
    //
    //
    //     try {
    //         // @ts-ignore
    //         const res:any = await post(url,false,formData);
    //         if (res.success){
    //             callToast(toast,true,res.data.message)
    //         }else {
    //             showErrors(res.error.errors || res.error,toast);
    //         }
    //     }catch (e) {
    //         catchError(e)
    //     }
    // }
    const updateBlog = async () => {
        const formData = new FormData();

        const payload: any = {
            ...blog,
        };

        for (const key in payload) {
            const value = payload[key as keyof typeof payload];

            if (value === null || value === undefined) continue;

            // send 1 or 0 for Laravel
            if (key === "is_published") {
                formData.append("is_published", blog?.is_published ? "1" : "0");
                continue;
            }

            // skip empty strings
            if (typeof value === "string" && value.trim().length === 0) continue;

            // handle separately
            if (key === "published_at") continue;
            if (key === "tags") continue;

            // skip existing image URL
            if (key === "image" && typeof value === "string") continue;
            if (key === "meta_image" && typeof value === "string") continue;

            // file upload
            if (key === "image" && value instanceof File) {
                formData.append("image", value);
                continue;
            }

            if (key === "meta_image" && value instanceof File) {
                formData.append("meta_image", value);
                continue;
            }

            // skip arrays here, handled separately
            if (Array.isArray(value)) continue;

            formData.append(key, String(value));
        }

        // append tags
        if (Array.isArray(blog?.tags) && blog.tags.length > 0) {
            blog.tags.forEach((tag: any) => {
                if (tag?.tag && String(tag.tag).trim().length > 0) {
                    formData.append("tags[]", tag.tag);
                }
            });
        }

        // append published_at
        if (blog?.published_at) {
            const formattedDate = moment(blog.published_at).format("YYYY-MM-DD");
            formData.append("published_at", formattedDate);
        }

        try {
            // @ts-ignore
            const res: any = await post(url, false, formData);

            if (res.success) {
                callToast(toast, true, res.data.message);
            } else {
                showErrors(res.error?.errors || res.error, toast);
            }
        } catch (e) {
            catchError(e);
        }
    };

    const handleTagKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            const value = (e.target as HTMLInputElement).value.trim();
            const id = Number(blog.tags.at(-1)?.id)+1
            if (!value) return;

            setBlog((prev: any) => ({
                ...prev,
                tags: [...(prev.tags || []), {id,tag:value}]
            }));

            (e.target as HTMLInputElement).value = "";
        }
    };

    const removeTag = (index: number) => {
        setBlog((prev: any) => ({
            ...prev,
            tags: prev.tags.filter((_: string, i: number) => i !== index)
        }));
    };

    const content = <div>
        <div className="grid">
            <div className="col-12 md:col-7">
                <div className="pr-2">
                    <div className="my-2">
                        <label className="font-medium">Title *</label>
                        <InputText name={'title'} value={blog?.title} className="w-full"  placeholder="Title"/>
                    </div>
                    <div className="p-fluid grid my-2">
                        <div className="col-12 md:col-4">
                            <label className="font-medium">Author *</label>
                            <InputText name={'author'} value={blog?.author} className="w-full"  placeholder="Author"/>
                        </div>
                        <div className="col-12 md:col-4">
                            <label className="font-medium">Category *</label>
                            <Dropdown value={category?.find((item:any)=>Number(item?.code)===Number(blog?.category_id))} onChange={(e) => {
                                setBlog({
                                    ...blog,
                                    category_id:e.value.code,
                                })
                            }} options={category}
                                      optionLabel="name"
                                      placeholder="Select a Category" className="w-full"/>
                        </div>

                        <div className="col-12 md:col-4">
                            <label className="font-medium">Publish Date</label>
                            <div className="mb-2">
                                <Calendar value={blog?.published_at} onChange={(e: any) => {
                                    setBlog({
                                        ...blog,
                                        published_at:e.value,
                                    })
                                }} placeholder={'Event date'}/>
                            </div>
                        </div>

                        <div className="col-12">
                            <label className="font-medium">Tags</label>
                            <div className="mb-2 flex">
                                {blog?.tags?.length > 0 &&
                                    blog.tags.map((tag: any, index: number) => (
                                        <Button
                                            key={index}
                                            label={tag?.tag}
                                            severity="secondary"
                                            className="mr-1 mb-1"
                                            size="small"
                                            outlined
                                            style={{width:'fit-content'}}
                                            icon="pi pi-times"
                                            iconPos="right"
                                            rounded
                                            onClick={() => removeTag(index)}
                                            type="button"
                                        />
                                    ))}
                            </div>

                            <InputText
                                placeholder="Type tag and press Enter"
                                className="w-full"
                                onKeyDown={handleTagKeyDown}
                            />
                        </div>


                    </div>
                    <div>
                        <label className="font-medium">Short Description *</label>
                        <InputTextarea placeholder={'Short Description'} name={'short_description'} value={blog.short_description} onChange={handleChange}
                                       className='w-full' style={{height: '100px'}}/>
                    </div>
                    <div>
                        <label className="font-medium">Details *</label>
                        {/*<TinyEditor*/}
                        {/*    value={blog.content}*/}
                        {/*    onChange={(content: string) =>*/}
                        {/*        setBlog((prev:any) => ({...prev, content}))*/}
                        {/*    }*/}
                        {/*/>*/}
                        <TextEditor
                            value={blog.content || ''}
                            setValue={(content: string) =>
                                setBlog((prev: any) => ({
                                    ...prev,
                                    content: content,
                                }))
                            }
                        />
                        {/*<Editor className='w-100' value={blog.content} style={{ height: '320px' }} />*/}
                    </div>
                </div>
            </div>
            <div className="col-12 md:col-5">
                <div className="pl-2">
                    <div className="col-12">
                        <label className="font-medium">Thumbnail Image (1024 kB max)</label>
                        <FileUpload
                            name="demo[]"
                            url="/api/upload"
                            multiple={false}
                            accept="image/*"
                            maxFileSize={1024*1024}
                            emptyTemplate={defaultImagePreviewer}
                            onSelect={onUpload}
                            onRemove={onRemove}
                        />

                    </div>
                </div>

                <div className="grid p-4">
                    <div className="col-12">
                        <h4 className="mb-3">SEO Information</h4>
                    </div>

                    {/* Meta Title */}
                    <div className="col-12">
                        <label className="font-medium">Meta Title</label>
                        <InputText
                            name="meta_title"
                            value={blog.meta_title || ""}
                            onChange={handleChange}
                            placeholder="Meta Title"
                            className="w-full"
                        />
                    </div>

                    {/* Meta Author */}
                    <div className="col-12 md:col-6">
                        <label className="font-medium">Meta Author</label>
                        <InputText
                            name="meta_author"
                            value={blog.meta_author || ""}
                            onChange={handleChange}
                            placeholder="Meta Author"
                            className="w-full"
                        />
                    </div>

                    {/* Meta Robots */}
                    <div className="col-12 md:col-6">
                        <label className="font-medium">Meta Robots</label>
                        <Dropdown
                            value={blog.meta_robots || ""}
                            options={[
                                { label: "Index, Follow", value: "index, follow" },
                                { label: "No Index, Follow", value: "noindex, follow" },
                                { label: "Index, No Follow", value: "index, nofollow" },
                                { label: "No Index, No Follow", value: "noindex, nofollow" }
                            ]}
                            onChange={(e) =>
                                setBlog({ ...blog, meta_robots: e.value })
                            }
                            placeholder="Select Robots Option"
                            className="w-full"
                        />
                    </div>

                    {/* Meta Description */}
                    <div className="col-12">
                        <label className="font-medium">Meta Description</label>
                        <InputTextarea
                            name="meta_description"
                            value={blog.meta_description || ""}
                            onChange={handleChange}
                            rows={4}
                            placeholder="Meta Description"
                            className="w-full"
                            autoResize
                        />
                    </div>

                    {/* Meta Keywords */}
                    <div className="col-12">
                        <label className="font-medium">Meta Keywords</label>
                        <InputText
                            name="meta_keywords"
                            value={blog.meta_keywords || ""}
                            onChange={handleChange}
                            placeholder="keyword1, keyword2, keyword3"
                            className="w-full"
                        />
                    </div>

                    {/* Meta Image Upload */}
                    <div className="col-12">
                        <label className="font-medium">Meta Image (1024 kB max)</label>
                        <FileUpload
                            name="demo[]"
                            url="/api/upload"
                            multiple={false}
                            accept="image/*"
                            maxFileSize={1024*1024}
                            emptyTemplate={defaultMetaImagePreviewer}
                            onSelect={onMetaUpload}
                            onRemove={onMetaRemove}
                        />
                    </div>
                </div>
            </div>
        </div>
        <div className="col-12 flex justify-content-end gap-2 mt-3">
            <Button loading={ploading} onClick={updateBlog} label="Update Innovation" icon="pi pi-check" />
        </div>
    </div>

    const loader = <div className="grid">
        <div className="col-12 md:col-7">
            <div className="pr-2">
                <Skeleton className="w-full mb-2" height="3rem"></Skeleton>
                <Skeleton className="w-full mb-2" height="3rem"></Skeleton>
                <Skeleton className="w-full mb-2" height="3rem"></Skeleton>
                <Skeleton className="w-full mb-2" height="6rem"></Skeleton>
                <Skeleton className="w-full mb-2" height="15rem"></Skeleton>
                <Skeleton className="w-full mb-2" height="20rem"></Skeleton>
            </div>
        </div>
        <div className="col-12 md:col-5">
            <div className="pl-2">
                <Skeleton className="w-full mb-2" height="10rem"></Skeleton>
                <Skeleton className="w-full mb-2" height="15rem"></Skeleton>
                <Skeleton className="w-full mb-2" height="20rem"></Skeleton>
                <Skeleton className="w-full mb-2" height="20rem"></Skeleton>
            </div>
        </div>
    </div>

    const header = (
        <div className="flex align-items-center justify-content-between p-4 pb-0">
            <h4 className="m-0">Innovation Details</h4>
            <div className="flex align-items-center">
                <label htmlFor="">Publish Now</label>
                <InputSwitch className="ml-2" name={'is_published'} checked={Number(blog.is_published) === 1} onChange={handleChange} />
            </div>
        </div>
    )

    return (
        <Card header={header}>
            <Toast ref={toast}/>
            {loading ? loader : content}
        </Card>
    );
};


export default InnovationDetails;